var FormulaireContact = {
    init:function(){
        console.log("contact.init");
        $(".souhait .custom-select select").on("change", function(){
            
            $(".souhait-complement .choix").each(function(){
                 if($(this).attr("data-value") == $(".souhait .custom-select select").val()){
                    $(this).addClass("visible");
                }else{
                    $(this).removeClass("visible");
                }
            })
        })
    }
}

$(window).load(function(){
    if($(".souhait-complement").length){
        FormulaireContact.init();
    }
})